export type LeadPriority = 'hot' | 'warm' | 'cold'

const LABELS: Record<LeadPriority, string> = {
  hot: 'Hot',
  warm: 'Warm',
  cold: 'Cold',
}

// Figma-exact: Hot #F344DF bg / #510041 text. Warm + Cold extrapolated
// on the same pattern (vivid fill with dark-of-same-hue text).
const STYLES: Record<LeadPriority, { bg: string; text: string; dot: string }> = {
  hot: { bg: '#F344DF', text: '#510041', dot: '#510041' },
  warm: { bg: '#FFC940', text: '#553600', dot: '#553600' },
  cold: { bg: '#5BE8F5', text: '#00363F', dot: '#00363F' },
}

export default function PriorityBadge({ priority }: { priority: LeadPriority }) {
  const s = STYLES[priority]
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded px-3 py-0.5 font-display text-xs font-medium"
      style={{ backgroundColor: s.bg, color: s.text }}
    >
      <span className="h-2 w-2 rounded-full" style={{ backgroundColor: s.dot }} />
      {LABELS[priority]}
    </span>
  )
}
